import React, { useEffect } from "react";
import Highlights from "../Component/Highlights";
import Search from "../Component/Search";
import { useLocation, NavLink, Link } from "react-router-dom";
const Header = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      <div className="topheader">
        <div className="topheaderli">
          <ul>
            <li>Enquiry </li>
            <li>
              <Link to="/Admission">Admission</Link>
            </li>
            <li>ERP Login</li>
            <li>
              <Link to="https://entab.online/SPCSFBD" target="_blank">
                Parent Portal
              </Link>
            </li>
          </ul>
        </div>
        <div className="topheaderbtn">
          <ul>
            <li>FAQ</li>
            <li>
              <Link to="/Newsletter">
                <img
                  src="https://webapi.entab.info/api/image/STPSFH/public/Images/Newslettericn.gif"
                  className="img-fluid"
                />
                Newsletter
              </Link>
            </li>
            <li>
              <Link to="/EPublication">
                <img
                  src="https://webapi.entab.info/api/image/STPSFH/public/Images/EPublicationicn.gif"
                  className="img-fluid"
                />
                E- Publication
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3">
          <div className="midheaderleft">
            <Link to="/">
              <img
                src="https://webapi.entab.info/api/image/STPSFH/public/Images/logo.png"
                className="img-fluid"
              />
            </Link>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="col-lg-12">
            <Highlights />
          </div>
          <div className="col-lg-12">
            <div className="paymentsearch">
              <div class="search">
                <Search />
              </div>
              <div class="scan">
                <img
                  src="https://webapi.entab.info/api/image/STPSFH/public/Images/scanimg.gif"
                  className="img-fluid"
                />
                <p>Scan QR for Fee Payment</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="navheader">
        <nav className="navbar navbar-expand-lg">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#main_nav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="main_nav">
            <ul className="navbar-nav">
              <li className="nav-item active">
                <NavLink className="dropdown-item" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  About Us
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink className="dropdown-item" to="/AboutUs">
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/OurSchool">
                      Our School
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/OurHeavenlyPatron">
                      Our Heavenly Patron
                    </NavLink>
                  </li>

                  <li class="innersubmenu">
                    <button
                      type="button"
                      className="menu-item dropdown-item d-flex justify-content-between align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const submenu = e.currentTarget.nextElementSibling;
                        submenu.classList.toggle("show");
                      }}
                    >
                      Management
                      <i className="bi bi-caret-right-fill"></i>
                    </button>



                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" href="/PrincipalMessage">
                          Principal’s Message
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="/ManagersMessage">
                          Manager’s Message
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="/FormerPrincipalMessage">
                          Former Principal’s Message
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="/CMCHistory">
                          CMC History
                        </a>
                      </li>
                    </ul>
                  </li>


                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/ManagementCommittee"
                    >
                      Management Committee
                    </NavLink>
                  </li>

                  <li class="innersubmenu">


                    <button
                      type="button"
                      className="menu-item dropdown-item d-flex justify-content-between align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const submenu = e.currentTarget.nextElementSibling;
                        submenu.classList.toggle("show");
                      }}
                    >
                      Campus
                      <i className="bi bi-caret-right-fill"></i>
                    </button>


                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" href="/Infrastructure">
                          Infrastructure
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="/Activities">
                          Activities
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Staff">
                      Staff
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Mission">
                      Mission
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Vision">
                      Vision
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/OurMotto">
                      Our Motto
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/OurUniqueness">
                      Our Uniqueness
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink className="dropdown-item" to="/Infrastructure">
                      Infrastructure
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink className="dropdown-item" to="/StudentStrength">
                      Student Strength
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/RulesRegulation">
                      Rules & Regulation
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  Admission
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink className="dropdown-item" to="/AcademicEntrance">
                      Entrance Exam Syllabus
                    </NavLink>
                  </li>

                  <li>
                    <a
                      class=""
                      href="https://drive.google.com/file/d/1PXoVuFkVIISjaWczqvLBW3VLRXUeXjym/view"
                      target="_blank"
                    >
                      Prospectus
                    </a>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Admission">
                      Admission Procedure
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/AdmissionXI">
                      Admission Class XI Information
                    </NavLink>
                  </li>
                  <li class="innersubmenu">

                    <button
                      type="button"
                      className="menu-item dropdown-item d-flex justify-content-between align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const submenu = e.currentTarget.nextElementSibling;
                        submenu.classList.toggle("show");
                      }}>
                      Interaction and Entrance<br/> Examination Result
                      <i className="bi bi-caret-right-fill"></i>
                    </button>

                    <ul class="dropdown-menu">
                      {/* <li>
                        <a class="" href="/Result">
                          Class Nur - IX
                        </a>
                      </li> */}
                      <li>
                        <a class="dropdown-item" href="/EntranceExamination">
                          XI Class Enterance Test Result
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Feestructure">
                      Fee structure
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  Academics
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink className="dropdown-item" to="/CoCurriculum">
                      Co-Curriculum
                    </NavLink>
                  </li>

                  <li class="innersubmenu">


                    <button
                      type="button"
                      className="menu-item dropdown-item d-flex justify-content-between align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const submenu = e.currentTarget.nextElementSibling;
                        submenu.classList.toggle("show");
                      }}>
                      Syllabus
                      <i className="bi bi-caret-right-fill"></i>
                    </button>


                    <ul class="dropdown-menu">
                      {/* <li>
                        <a class="" href="/EntranceExamClassXI">
                          Entrance Exam Class XI
                        </a>
                      </li> */}
                      <li>
                        <a class="dropdown-item" href="Termone">
                          Term-1
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="Termtwo">
                          Term-2
                        </a>
                      </li>
                      {/* <li class="innersubmenu">
                        <a href="javascript:void(0)" class="menu-item">
                          Term-2
                          <span>
                            <i class="bi bi-caret-right-fill"></i>
                          </span>
                        </a>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/SecondarySyllabus.pdf"
                              target="_blank"
                            >
                              Secondary Stage
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/MiddleSyllabus.pdf"
                              target="_blank"
                            >
                              Middle Stage
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/PreparatorySyllabus.pdf"
                              target="_blank"
                            >
                              Preparatory Stage
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/FoundationalSyllabus.pdf"
                              target="_blank"
                            >
                              Foundational Stage
                            </a>
                          </li>

                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ukg.pdf"
                              target="_blank"
                            >
                              UKG
                            </a>
                          </li>

                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/lkg.pdf"
                              target="_blank"
                            >
                              LKG
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/nur.pdf"
                              target="_blank"
                            >
                              Nursery
                            </a>
                          </li>

                        </ul>
                      </li>  */}
                    </ul>
                  </li>
                  {/*  <li><NavLink  className="dropdown-item" to="https://webapi.entab.info/api/image/STPSFH/public/pdf/Syllabus.pdf" target="_blank">Syllabus </NavLink></li> */}
                  <li>
                    <NavLink className="dropdown-item" to="/HolidaysHomework">
                      Curriculum Extension Activities
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Courses">
                      Courses
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Circular">
                      Circular
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/CBSECircular">
                      CBSE Circular
                    </NavLink>
                  </li>
                  <li class="innersubmenu">
                    <button
                      type="button"
                      className="menu-item dropdown-item d-flex justify-content-between align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const submenu = e.currentTarget.nextElementSibling;
                        submenu.classList.toggle("show");
                      }}>
                      Datesheet
                      <i className="bi bi-caret-right-fill"></i>
                    </button>

                    <ul class="dropdown-menu">
                      {/* <li>
                        <a class="" href="/EntranceExamClassXI">
                          Entrance Exam Class XI
                        </a>
                      </li> */}
                      <li>
                        <NavLink class="dropdown-item" to="/datesheet-one">
                          Term-1
                        </NavLink>
                      </li>
                      <li>
                        <NavLink class="dropdown-item" to="/datesheet-two">
                          Term-2
                        </NavLink>
                      </li>
                      {/* <li class="innersubmenu">
                        <a href="javascript:void(0)" class="menu-item">
                          Term-2
                          <span>
                            <i class="bi bi-caret-right-fill"></i>
                          </span>
                        </a>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/SecondarySyllabus.pdf"
                              target="_blank"
                            >
                              Secondary Stage
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/MiddleSyllabus.pdf"
                              target="_blank"
                            >
                              Middle Stage
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/PreparatorySyllabus.pdf"
                              target="_blank"
                            >
                              Preparatory Stage
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/FoundationalSyllabus.pdf"
                              target="_blank"
                            >
                              Foundational Stage
                            </a>
                          </li>

                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ukg.pdf"
                              target="_blank"
                            >
                              UKG
                            </a>
                          </li>

                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/lkg.pdf"
                              target="_blank"
                            >
                              LKG
                            </a>
                          </li>
                          <li>
                            <a
                              class=""
                              href="https://webapi.entab.info/api/image/STPSFH/public/pdf/nur.pdf"
                              target="_blank"
                            >
                              Nursery
                            </a>
                          </li>

                        </ul>
                      </li>  */}
                    </ul>
                  </li>
                  {/* <li>
                    <NavLink className="dropdown-item" to="/ToTheParents">
                      To the Parents
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink className="dropdown-item" to="/SchoolTiming">
                      School Timing
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/SchoolTransportation"
                    >
                      School Transportation
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/SchoolUniform">
                      School Uniform
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/LibraryRules">
                      Library Rules
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/Classroom">
                      Classroom Rules
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/SchoolFees">
                      School Fees
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://webapi.entab.info/api/image/STPSFH/public/pdf/Book-list.pdf"
                      target="_blank"
                    >
                      List of Text Books
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://webapi.entab.info/api/image/STPSFH/public/pdf/SPCS-pedagogical-planner.pdf"
                      target="_blank"
                    >
                      Pedagogical Planner
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://webapi.entab.info/api/image/STPSFH/public/pdf/Syllabus-A3-Black.pdf"
                      target="_blank"
                    >
                      Holistic Report Card Planner
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  Gallery
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink className="dropdown-item" to="/Gallery">
                      Gallery
                    </NavLink>
                  </li>

                  {/* <li>
                    <NavLink className="dropdown-item" to="/Activity">
                      Activity
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/OutReachProgram">
                      OutReach Program
                    </NavLink>
                  </li> */}

                  <li class="innersubmenu">

                    <button
                      type="button"
                      className="menu-item dropdown-item d-flex justify-content-between align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const submenu = e.currentTarget.nextElementSibling;
                        submenu.classList.toggle("show");
                      }}>
                      Video Gallery
                      <i className="bi bi-caret-right-fill"></i>
                    </button>

                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" href="/VideoGallery">
                          Video Gallery
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="/LifeTags">
                          Life Tags
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* <li>
                    <NavLink className="dropdown-item" to="/CovidResponse">
                      Covid Response
                    </NavLink>
                  </li> */}
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  Events
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink className="dropdown-item" to="/Events">
                      Events
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/GlimpseOfTheDay">
                      Glimpse of the day
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/ThoughtOfTheDay">
                      Thought of the day
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink className="dropdown-item" to="/CbseDisclosure">
                  CBSE
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  Alumni
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink className="dropdown-item" to="/AluminiAssociation">
                      Alumni Association
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink className="dropdown-item" to="/ContactUs">
                  Contact Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="dropdown-item" to="/career">
                  Career
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
